module.exports = __webpack_public_path__ + "static/media/SPRAY-BG.29c61d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY-BG.png
// module id = 278
// module chunks = 0